export const FIRST_TIME_MYZONE_KEY = "c8_myzone_first_time";

export const HISTORY_CACHE_KEY_PREFIX = "c8_my_games_history";
export const HISTORY_CACHE_TTL_MS = 90_000;

export const QUICKFIRE_MONTHS_UPPER = [
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER",
] as const;

export const QUICKFIRE_SUMMARY_WEEKDAYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"] as const;

export const SLIM_FOOTER_COIN_LABEL =
    "font-chakra-petch text-[9px] font-normal leading-[15px] tracking-[0] text-right text-white";
export const SLIM_FOOTER_COIN_AMOUNT =
    "font-chakra-petch text-[9px] font-bold leading-[15px] tracking-[0] text-right text-white";
export const SLIM_FOOTER_COIN_LABEL_LIME =
    "font-chakra-petch text-[9px] font-normal leading-[15px] tracking-[0] text-right text-[#d4ff1f]";
export const SLIM_FOOTER_COIN_AMOUNT_LIME =
    "font-chakra-petch text-[9px] font-bold leading-[15px] tracking-[0] text-right text-[#d4ff1f]";

/** Purple hero: Anton 14 / 400 / uppercase / leading 100% / tracking 0 — team + match line */
export const MATCH_HERO_CLASS =
    "font-anton text-[14px] font-normal uppercase leading-[100%] tracking-normal align-middle";

/** Summary modal white strip: team names — Anton 10 / 400 / lh 15px / tracking 0 / leading-trim none / uppercase / middle */
export const MYZONE_SUMMARY_WHITE_STRIP_MATCH_CLASS =
    "font-anton text-[10px] font-normal not-italic uppercase leading-[15px] tracking-[0] [leading-trim:none] align-middle";

/** Summary modal white strip: “V” between teams — same typography as team names; pair with `text-main/30` */
export const MYZONE_SUMMARY_WHITE_STRIP_VS_CLASS =
    "font-anton text-[10px] font-normal not-italic uppercase leading-[15px] tracking-[0] [leading-trim:none] align-middle";

/** My Zone modal white-strip date: Anton 12 / 400 / uppercase / lh 100%, slightly under team line (14), right, muted */
export const MYZONE_WHITE_STRIP_DATE_CLASS =
    "font-anton text-[12px] font-normal uppercase leading-[100%] tracking-normal text-right align-middle text-main/40";

/** Purple game-type header row: date beside Active/Finished — Anton 10 / 400 / lh 15px / uppercase / right / leading-trim none */
export const MYZONE_PURPLE_HEADER_DATE_CLASS =
    "shrink-0 font-anton text-[10px] font-normal not-italic uppercase leading-[15px] tracking-normal text-right text-white/65 [leading-trim:none]";

/** Squares single-over + My Zone trader detail stat labels: Anton 12 / 400 / uppercase / lh 100% / tracking 0 */
export const MYZONE_SQUARES_STAT_LABEL_CLASS =
    "font-anton text-[12px] font-normal uppercase leading-[100%] tracking-normal text-center align-middle text-white/50";

/** BULLION summary modal stat tiles: Correct / Points / Position / Coins won labels — Anton 12 / 400 / lh 100% / center / 40% */
export const MYZONE_BULLION_SUMMARY_STAT_LABEL_CLASS =
    "font-anton text-[12px] font-normal not-italic uppercase leading-[100%] tracking-normal text-center align-middle text-white/40 [leading-trim:none]";

/** BULLION summary modal purple header: “BULLION” wordmark beside icon — Anton 16 / 400 / lh 12px / tracking 0 / leading-trim none / uppercase; `py-1` pads line box so caps aren’t clipped vs 12px leading. */
export const MYZONE_BULLION_SUMMARY_HEADER_GAME_NAME_CLASS =
    "min-w-0 flex-1 truncate py-1 font-anton text-[16px] font-normal not-italic uppercase leading-[12px] tracking-[0] [leading-trim:none] text-white align-middle";

/** Sixes summary modal header icon — 24×24 */
export const MYZONE_SIXES_SUMMARY_HEADER_ICON_CLASS =
    "h-[24px] w-[24px] min-h-[24px] min-w-[24px] max-h-[24px] max-w-[24px] shrink-0 object-contain";

/** Sixes summary modal header “SIXES” — Anton 16 / 400 / lh 12px / tracking 0 / uppercase */
export const MYZONE_SIXES_SUMMARY_HEADER_TITLE_CLASS =
    "min-w-0 flex-1 truncate py-1 font-anton text-[16px] font-normal not-italic uppercase leading-[12px] tracking-[0] [leading-trim:none] text-white align-middle";

/** Sixes lobby “MY SIXES CARDS” drawer title — Anton 16 / 400 / lh 16px / center / uppercase; `py-1` avoids cap clipping. */
export const MYZONE_SIXES_LOBBY_DRAWER_TITLE_CLASS =
    "min-w-0 flex-1 truncate py-1 text-center align-middle font-anton text-[16px] font-normal not-italic uppercase leading-[16px] tracking-[0] [leading-trim:none] text-white";

/** Sixes lobby drawer header row — room for Anton caps + centered title row */
export const MYZONE_SIXES_LOBBY_DRAWER_HEADER_CLASS = "!py-3 md:!py-4 overflow-visible";

/** Sixes lobby “MY SIXES CARDS” modal — sit higher on screen (above bottom banner). */
export const MYZONE_SIXES_LOBBY_DRAWER_PANEL_POSITION_CLASS =
    "items-start justify-center pt-[5vh] sm:pt-[7vh] md:pt-[9vh]";

/** Sixes lobby “MY SIXES CARDS” modal shell background */
export const MYZONE_SIXES_LOBBY_DRAWER_SHELL_CLASS = "bg-[#461D79]";

/** Sixes list card footer (wins / sets / coins row) */
export const MYZONE_SIXES_LIST_CARD_FOOTER_BG_CLASS = "bg-[#4f2189]";

/** Sixes list card top band (date + team names) */
export const MYZONE_SIXES_LIST_CARD_TOP_BG_CLASS = "bg-[#652DAF]";

/** Sixes list card thumb (game icon box) */
export const MYZONE_SIXES_LIST_CARD_THUMB_BG_CLASS = "bg-[#9747FF]";

/** Sixes summary modal header date — Anton 10 / 400 / lh 15px / tracking 0 / right / uppercase / muted */
export const MYZONE_SIXES_SUMMARY_HEADER_DATE_CLASS =
    "shrink-0 max-w-[120px] truncate font-anton text-[10px] font-normal not-italic uppercase leading-[15px] tracking-[0] text-right text-white/65 [leading-trim:none] sm:max-w-none";

/** Sixes summary modal status pill shell — min 42×21 */
export const MYZONE_SIXES_SUMMARY_STATUS_PILL_SHELL_CLASS =
    "inline-flex h-[21px] min-h-[21px] min-w-[42px] max-h-[21px] shrink-0 items-center justify-center rounded-none px-1 font-anton text-[10px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none]";

/** Sixes summary modal “Finished” pill — lime fill */
export const MYZONE_SIXES_SUMMARY_FINISHED_PILL_CLASS =
    `${MYZONE_SIXES_SUMMARY_STATUS_PILL_SHELL_CLASS} bg-[#32F78D] text-[#1B062F]`;

/** Sixes summary modal “Active” pill — pink fill (open / in-play cards) */
export const MYZONE_SIXES_SUMMARY_ACTIVE_PILL_CLASS =
    `${MYZONE_SIXES_SUMMARY_STATUS_PILL_SHELL_CLASS} bg-[#F73261] text-white`;

/** Sixes summary modal “Void” pill — amber fill */
export const MYZONE_SIXES_SUMMARY_VOID_PILL_CLASS =
    `${MYZONE_SIXES_SUMMARY_STATUS_PILL_SHELL_CLASS} bg-[#EAB308] text-[#1B062F]`;

/** Sixes summary stats row — full-bleed tiles; gap shows divider lines */
export const MYZONE_SIXES_SUMMARY_STATS_ROW_CLASS =
    "flex min-w-0 gap-0.5 border-y border-[#6f3fbe]/30 bg-[#461d79] pt-1 sm:gap-px";

/** Sixes summary footer — inset GO TO CARD on shell purple */
export const MYZONE_SIXES_SUMMARY_FOOTER_CLASS = "shrink-0 bg-[#461d79] px-3 pb-3 pt-2";

/** Sixes summary GO TO CARD — 40px lime CTA (label class applied in modal) */
export const MYZONE_SIXES_SUMMARY_GO_TO_CARD_BUTTON_SHELL_CLASS =
    "flex h-[40px] min-h-[40px] max-h-[40px] w-full shrink-0 items-center justify-center rounded-none bg-lime px-4 hover:bg-limehover";

/** Coin icon beside coins-won value (mock: left of amount, not in label) */
export const MYZONE_SIXES_SUMMARY_STAT_COIN_ICON_CLASS =
    "h-4 w-4 min-h-[16px] min-w-[16px] shrink-0 object-contain";

/** Sixes summary modal white team strip — 36px tall */
export const MYZONE_SIXES_SUMMARY_WHITE_STRIP_ROW_CLASS =
    "relative flex h-[36px] min-h-[36px] max-h-[36px] w-full min-w-0 items-center justify-between px-2 sm:px-3";

/** Sixes summary white strip team names — Anton 14 / 400 / lh 100% / tracking 0 / uppercase */
export const MYZONE_SIXES_SUMMARY_WHITE_STRIP_TEAM_NAME_CLASS =
    "font-anton text-[14px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] align-middle";

/** Sixes summary white strip “V” — same scale as team names; pair with `text-main/30` */
export const MYZONE_SIXES_SUMMARY_WHITE_STRIP_VS_CLASS =
    "shrink-0 font-anton text-[14px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] align-middle";

/** Sixes summary modal stat tiles (Wins / Sets / Sixes / Coins) — fixed 60px tall */
export const MYZONE_SIXES_SUMMARY_STAT_TILE_CLASS =
    "flex h-[60px] min-h-[60px] max-h-[60px] min-w-0 flex-1 flex-col items-center justify-center gap-0.5 bg-[#652dae] px-1.5 text-center";

/** Sixes summary stat tile labels (WINS / SETS / SIXES / COINS WON) — Anton 12 / 400 / lh 100% / center / uppercase */
export const MYZONE_SIXES_SUMMARY_STAT_LABEL_CLASS =
    "font-anton text-[12px] font-normal not-italic uppercase leading-[100%] tracking-[0] text-center align-middle text-white/40 [leading-trim:none]";

/** Sixes summary stat tile values — Anton 20 / 400 / lh 100% / center / uppercase / tabular-nums */
export const MYZONE_SIXES_SUMMARY_STAT_VALUE_CLASS =
    "font-anton text-[20px] font-normal not-italic uppercase leading-[100%] tracking-[0] text-center align-middle tabular-nums text-white [leading-trim:none]";

/** BULLION summary modal stat tile values — Anton 20 / 400 / lh 100% / center / uppercase */
export const MYZONE_BULLION_SUMMARY_STAT_VALUE_CLASS =
    "font-anton text-[20px] font-normal not-italic uppercase leading-[100%] tracking-normal text-center align-middle tabular-nums text-white [leading-trim:none]";

/** Squares single-over stat values (over number, place, coins): Anton 20 / 400 / uppercase / lh 100% / tracking 0 */
export const MYZONE_SQUARES_STAT_VALUE_CLASS =
    "font-anton text-[20px] font-normal uppercase leading-[100%] tracking-normal text-center align-middle tabular-nums text-white";

/** Squares summary Final standings: profile / letter avatar — fixed 30×30 */
export const MYZONE_SQUARES_SUMMARY_LEADERBOARD_AVATAR_CLASS =
    "h-[30px] w-[30px] shrink-0";

/** Squares summary Final standings: chip count left of chip icon — reserved 30px-wide slot; Chakra Petch 16 / 400 / lh 100% / tracking 0 / leading-trim none / right / tabular-nums */
export const MYZONE_SQUARES_SUMMARY_LEADERBOARD_CHIPS_AMOUNT_CLASS =
    "block w-[30px] min-w-[30px] max-w-[30px] shrink-0 truncate text-right font-chakra-petch text-[16px] font-normal not-italic leading-[100%] tracking-[0] [leading-trim:none] tabular-nums text-white";

/** Squares summary Final standings: coin return amount beside coin icon — Chakra Petch 12 / 400 / lh 100% / tracking 0 / leading-trim none */
export const MYZONE_SQUARES_SUMMARY_LEADERBOARD_COINS_NUMBER_CLASS =
    "font-chakra-petch text-[12px] font-normal not-italic leading-[100%] tracking-[0] [leading-trim:none] tabular-nums text-white";

/** Squares summary Final standings: rank badge — fixed 20×20 */
export const MYZONE_SQUARES_SUMMARY_LEADERBOARD_RANK_CLASS =
    "h-[20px] w-[20px] shrink-0";

/** Squares summary Final standings: player name — Anton 16 / 400 / uppercase / lh 24px / tracking 0 / leading-trim none / middle */
export const MYZONE_SQUARES_SUMMARY_LEADERBOARD_USER_NAME_CLASS =
    "font-anton text-[16px] font-normal not-italic uppercase leading-[24px] tracking-[0] [leading-trim:none] align-middle text-white";

/** Squares single-over header: “Entrance” + formatted stake — Chakra Petch 11 / 400 / lh 100% / tracking 0 / right */
export const MYZONE_SQUARES_HEADER_ENTRANCE_CLASS =
    "font-chakra-petch text-[11px] font-normal leading-[100%] tracking-normal text-right text-white tabular-nums";

/** Squares modal header wordmark “SQUARES”: Anton 16 / 400 / uppercase / 12px lh / tracking 0 */
export const MYZONE_SQUARES_HEADER_TITLE_CLASS =
    "font-anton text-[16px] font-normal uppercase leading-[12px] tracking-normal text-white";

/** My Zone trader modal header wordmark “TRADER”: Anton 16 / 400 / uppercase / 12px lh / tracking 0 */
export const MYZONE_TRADER_HEADER_TITLE_CLASS =
    "font-anton text-[16px] font-normal uppercase leading-[12px] tracking-normal text-white";

/** My Zone Quickfire section + summary modal header “QUICKFIRE”: Anton 16 / 400 / uppercase / 12px lh / tracking 0 */
export const MYZONE_QUICKFIRE_HEADER_TITLE_CLASS =
    "font-anton text-[16px] font-normal uppercase leading-[12px] tracking-normal text-white";

/** Quickfire summary modal: “Correct” / “Coins won” labels — Anton 12 / 400 / lh 100% / center / middle / uppercase / white 50% */
export const MYZONE_QUICKFIRE_SUMMARY_STAT_LABEL_CLASS =
    "font-anton text-[12px] font-normal uppercase leading-[100%] tracking-normal text-center align-middle text-white/50";

/** Quickfire summary modal: question index in top tile (62px row) — Anton 20 / 400 / lh 15px / center / middle / uppercase */
export const MYZONE_QUICKFIRE_SUMMARY_QUESTION_NUM_CLASS =
    "font-anton text-[20px] font-normal uppercase leading-[15px] tracking-normal text-center align-middle text-[#1B062F]";

/** Quickfire summary modal: coin amount under each question — Chakra Petch 12 / 400 / lh 100% / tracking 0 / center / white */
export const MYZONE_QUICKFIRE_SUMMARY_QUESTION_COINS_CLASS =
    "min-w-0 truncate text-center font-chakra-petch text-[12px] font-normal leading-[100%] tracking-normal text-white";

/** Trader trade-card purple header: match line — Chakra Petch 10 / 400 / lh 100% / tracking 0 / middle */
export const MYZONE_TRADER_TRADE_CARD_MATCH_NAME_CLASS =
    "font-chakra-petch text-[10px] font-normal leading-[100%] tracking-normal align-middle";

/** My Zone headers: small lowercase “v” between team names — Chakra Petch 8 / 400 / lh 100% */
export const MYZONE_HEADER_MATCH_VS_CLASS =
    "font-chakra-petch text-[8px] font-normal leading-[100%] tracking-normal align-middle normal-case";

/** Trader trade-card body: market / trade type label (e.g. MATCH WINNER) — Anton 12 / 400 / lh 100% / tracking 0; add `uppercase` when not “Correct Score” */
export const MYZONE_TRADER_TRADE_TYPE_LABEL_CLASS =
    "font-anton text-[12px] font-normal leading-[100%] tracking-normal text-main";

/** Trader trade-card body: user selection (pick, right) — Chakra Petch 12 / 400 / lh 100% / tracking 0 / leading-trim none / right */
export const MYZONE_TRADER_TRADE_SELECTION_CLASS =
    "min-w-0 text-right font-chakra-petch text-[12px] font-normal not-italic leading-[100%] tracking-[0] [leading-trim:none] text-main";

/** Trader trade-card footer: “PRICE” (“Odds”) label — Chakra Petch 9 / 400 / lh 100% / uppercase / tracking 0 / leading-trim none */
export const MYZONE_TRADER_TRADE_ODDS_LABEL_CLASS =
    "font-chakra-petch text-[9px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-main/60";

/** Trader trade-card footer: odds value pill — fixed 40×20px; Chakra Petch 10 / 400 / lh 10px / tracking 0 / leading-trim none / center / uppercase / tabular-nums */
export const MYZONE_TRADER_TRADE_ODDS_VALUE_BOX_CLASS =
    "inline-flex h-5 min-h-[20px] w-[40px] min-w-[40px] max-w-[40px] shrink-0 items-center justify-center truncate bg-[#a8d4f0] px-0.5 font-chakra-petch text-[10px] font-normal not-italic uppercase leading-[10px] tracking-[0] [leading-trim:none] text-center tabular-nums text-main";

/** Trader trade-card footer: “ENTRY” label — Chakra Petch 9 / 400 / lh 100% / uppercase / tracking 0 / leading-trim none */
export const MYZONE_TRADER_TRADE_STAKE_LABEL_CLASS =
    "font-chakra-petch text-[9px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-main/60";

/** Trader trade-card footer: stake amount — Chakra Petch 10 / 700 / lh 100% / uppercase / tabular-nums / tracking 0 / leading-trim none */
export const MYZONE_TRADER_TRADE_STAKE_VALUE_CLASS =
    "shrink-0 font-chakra-petch text-[10px] font-bold not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-main tabular-nums";

/** Trader trade-card footer: “RETURNS” / “POT. RETURNS” label — Chakra Petch 9 / 400 / lh 100% / right / uppercase / tracking 0 / leading-trim none */
export const MYZONE_TRADER_TRADE_RETURNS_LABEL_CLASS =
    "font-chakra-petch text-[9px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-right text-main/60";

/** Trader trade-card footer: returns amount shell — 20px tall; pair with pl-0 pr-0 (active) or px-1 (settled pill) */
export const MYZONE_TRADER_TRADE_RETURNS_VALUE_BOX_CLASS =
    "inline-flex h-5 min-h-[20px] shrink-0 items-center justify-end";

/** Trader trade-card footer: returns amount — Chakra Petch 10 / 700 / lh 100% / right / uppercase / tabular-nums / tracking 0 / leading-trim none */
export const MYZONE_TRADER_TRADE_RETURNS_VALUE_CLASS =
    "font-chakra-petch text-[10px] font-bold not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-right tabular-nums";

/** Trader trade-card footer: coin icon beside stake / returns (16×16) */
export const MYZONE_TRADER_TRADE_FOOTER_COIN_ICON_CLASS = "h-[16px] w-[16px] shrink-0";

/** White card row: Active / Settled / Void (pink pill) — Anton 10 / 400 / uppercase / lh 100% / tracking 0 / center */
export const MYZONE_CARD_HEADER_STATUS_CLASS =
    "font-anton text-[10px] font-normal uppercase leading-[100%] tracking-normal text-center align-middle";

/** Trader / Squares modal header Active + Finished: Anton 10 / 400 / uppercase / lh 100% / tracking 0 */
export const MYZONE_HEADER_STATUS_PILL_CLASS =
    "inline-flex h-[22px] min-h-[22px] shrink-0 items-center justify-center px-2.5 py-1 font-anton text-[10px] font-normal uppercase leading-[100%] tracking-normal";

/** My Zone trader detail footer primary CTA (MATCH RESULTS or SEE MATCH when live + active trades) — Anton 16 / 400 / uppercase */
export const MYZONE_TRADER_MATCH_RESULTS_BUTTON_CLASS =
    "flex h-10 min-h-[40px] shrink-0 items-center justify-center px-3 font-anton text-[16px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-center align-middle text-[#1B062F]";

/** Summary modals — “Go to match” label (lime CTA) — Anton 16 / 400 / uppercase / lh 100% / tracking 0 / leading-trim none / center / middle. Pair with flex + bg on the button. */
export const MYZONE_GO_TO_MATCH_BUTTON_LABEL_CLASS =
    "text-center align-middle font-anton text-[16px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-[#1B062F]";

/** Trader / Squares / Quickfire / Bullion My Zone summary modals: same viewport slot (top-aligned, shared inset). */
export const MYZONE_GAME_SUMMARY_MODAL_SLOT_CLASS =
    "fixed inset-0 z-[10031] flex items-start justify-center px-2 pb-4 pt-10 sm:px-4 sm:pb-4 sm:pt-14 pointer-events-none";

/** My Games / My Zone: wraps each game-type list (7% opaque white over page background). */
export const MYZONE_GAME_CONTAINER_BG_CLASS = "bg-white/[0.07]";

/**
 * Game-type title in section headers (Trader / Squares / Quickfire / Bullion) — Anton 14 / 400 / uppercase / lh 25px / tracking 0.
 */
export const MYZONE_GAME_CONTAINER_TITLE_CLASS =
    "font-anton text-[14px] font-normal not-italic uppercase leading-[25px] tracking-[0] [leading-trim:none] text-white";

/** My Games game-type section header count badge — fixed 18×18 pink square; Anton 12 / 400 / uppercase / lh 10px / centered. */
export const MYZONE_GAME_CONTAINER_COUNT_BADGE_CLASS =
    "inline-flex h-[18px] w-[18px] min-h-[18px] min-w-[18px] max-h-[18px] max-w-[18px] shrink-0 items-center justify-center bg-[#F73261] text-center align-middle font-anton text-[12px] font-normal not-italic uppercase leading-[10px] tracking-[0] [leading-trim:none] text-white tabular-nums";

/** PAST row card short date (D-M-YYYY) — Anton 10 / 400 / uppercase / lh 100% / tracking 0 / white 50%; left-aligned above match teams (or after “OVER n”). */
export const MYZONE_PAST_CARD_DATE_CLASS =
    "text-left align-middle font-anton text-[10px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-white/50 shrink-0 whitespace-nowrap";

/** My Zone game card title stack — anchor / date row(s) above match teams (~4px gap). */
export const MYZONE_GAME_CARD_TITLE_COLUMN_CLASS =
    "flex min-w-0 flex-1 flex-col items-start justify-center gap-1 overflow-hidden text-left";

/** My Zone game card team names — Anton 14 / 400 / uppercase / lh 100% / white. */
export const MYZONE_GAME_CARD_TEAM_NAME_CLASS =
    "min-w-0 truncate align-middle font-anton text-[14px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-white";

/** My Zone game card “V” between teams — same scale as team names, white 30%. */
export const MYZONE_GAME_CARD_TEAM_VS_CLASS =
    "shrink-0 align-middle font-anton text-[14px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-white/30";

/** My Zone game list cards: coins won amount next to coin icon — bold tabular numerals. */
export const MYZONE_GAME_CARD_COINS_WON_AMOUNT_CLASS = "font-bold tabular-nums";

/** Settled Quickfire top title (session date; `uppercase` for display) — Anton 14 / 400 / lh 100% / tracking 0 / leading-trim none / white / align-middle. */
export const MYZONE_QUICKFIRE_PAST_SESSION_TITLE_CLASS =
    "align-middle font-anton text-[14px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-white";
